/**
 * @Author: sunchao
 * @Date:   2019/5/27 17:28
 */

import request from '@/util/request';
import apirequest from '@/util/api-request';


export const auth = (data: any, headers: any) => {
    return request({
        url: '/auth/hubei',
        method: 'post',
        data,
        headers,
    });
};

export const silenceAuth = (data: any, headers: any) => {
    return request({
        url: '/auth/hubei/silence-auth',
        method: 'post',
        data,
        headers,
    });
};

export const getUserInfo = () => {
    return request({
        url: '/auth/hubei/user-info',
        method: 'get'
    });
};
export const getlable = () => {
    return request({
        url: '/auth/hubei/auth-label',
        method: 'get',
    });
};
export const getServiceLable = (data: any) => {
    return apirequest({
        url: '/auth/hubei/auth-label',
        method: 'post',
        data: data,
        headers: {"Content-Type": "application/json"}
    });
};
export const serviceAuth = (key: string,data: any, headers: any) => {
    return apirequest({
        url: '/auth/hubei/service/'+key,
        method: 'post',
        data: data,
        headers: headers
    });
};
export const getTokenUser = (token: string) => {
    return apirequest({
        url: '/member/v1/get-token/' + token,
        method: 'get',
    });
};